export const PROFILE = {
  GET_PROFILE_ME: 'GET_PROFILE_ME',
  GET_PROFILE_ME_SUCCESS: 'GET_PROFILE_ME_SUCCESS',
  GET_PROFILE_ME_FAIL: 'GET_PROFILE_ME_FAIL',

  GET_PROFILE_ME_AVATAR: 'GET_PROFILE_ME_AVATAR',
  GET_PROFILE_ME_AVATAR_SUCCESS: 'GET_PROFILE_ME_AVATAR_SUCCESS',
  GET_PROFILE_ME_AVATAR_FAIL: 'GET_PROFILE_ME_AVATAR_FAIL',

  POST_PROFILE_DETAILS: 'POST_PROFILE_DETAILS',
  EDIT_USER: 'EDIT_USER',
  EDIT_USER_AVATAR: 'EDIT_USER_AVATAR',
  REMOVE_USER_AVATAR: 'REMOVE_USER_AVATAR',
  CHANGE_USER_PASSWORD: 'CHANGE_USER_PASSWORD',
  DELETE_PROFILE_ME_AVATAR: 'DELETE_PROFILE_ME_AVATAR',
  POST_PROFILE_ME_AVATAR: 'POST_PROFILE_ME_AVATAR',
  PATCH_PROFILE_ME_SETTINGS: 'PATCH_PROFILE_ME_SETTINGS',
  POST_PROFILE_PASSWORD: 'POST_PROFILE_PASSWORD',
  PATCH_PROFILE_NOTIFICATION: 'PATCH_PROFILE_NOTIFICATION',

  POST_PROFILE_NOTIFICATION_READ: 'POST_PROFILE_NOTIFICATION_READ',

  GET_USER_ROLES: 'GET_USER_ROLES',
  GET_USER_ROLES_SUCCESS: 'GET_USER_ROLES_SUCCESS',
  GET_USER_ROLES_FAIL: 'GET_USER_ROLES_FAIL',

  CLEAR_USER_ROLES: 'CLEAR_USER_ROLES',
  GET_SOCIALS_PROVIDER: 'GET_SOCIALS_PROVIDER',

  GET_PROFILE_ME_NOTIFICATIONS: 'GET_PROFILE_ME_NOTIFICATIONS',
  GET_PROFILE_ME_NOTIFICATIONS_SUCCESS: 'GET_PROFILE_ME_NOTIFICATIONS_SUCCESS',
  GET_PROFILE_ME_NOTIFICATIONS_FAIL: 'GET_PROFILE_ME_NOTIFICATIONS_FAIL',

  CLEAR_NOTIFICATION_LIST: 'CLEAR_NOTIFICATION_LIST',

  PROFILE_REMOVE_NOTIFICATION: 'PROFILE_REMOVE_NOTIFICATION',
  PROFILE_REMOVE_NOTIFICATION_SUCCESS: 'PROFILE_REMOVE_NOTIFICATION_SUCCESS',
  PROFILE_REMOVE_NOTIFICATION_FAIL: 'PROFILE_REMOVE_NOTIFICATION_FAIL',

  PROFILE_UPDATE_NOTIFICATION_COUNT: 'PROFILE_UPDATE_NOTIFICATION_COUNT',

  ADD_NOTIFICATION_PUSHER: 'ADD_NOTIFICATION_PUSHER',

  PROFILE_READ_NOTIFICATION: 'PROFILE_READ_NOTIFICATION',
  PROFILE_READ_NOTIFICATION_SUCCESS: 'PROFILE_READ_NOTIFICATION_SUCCESS',
  PROFILE_READ_NOTIFICATION_FAIL: 'PROFILE_READ_NOTIFICATION_FAIL',

  PROFILE_READ_ALL_NOTIFICATION: 'PROFILE_READ_ALL_NOTIFICATION',
  PROFILE_READ_ALL_NOTIFICATION_SUCCESS: 'PROFILE_READ_ALL_NOTIFICATION_SUCCESS',
  PROFILE_READ_ALL_NOTIFICATION_FAIL: 'PROFILE_READ_ALL_NOTIFICATION_FAIL',

  PROFILE_READ__NOTIFICATION_PUSHER: 'PROFILE_READ__NOTIFICATION_PUSHER',
  PROFILE_READ_ALL_NOTIFICATION_PUSHER_ALL: 'PROFILE_READ_ALL_NOTIFICATION_PUSHER_ALL',
  PROFILE_DELETE_NOTIFICATION_PUSHER: 'PROFILE_DELETE_NOTIFICATION_PUSHER',

};
